import { render, staticRenderFns } from "./CancelProcedure.vue?vue&type=template&id=751842b4&"
import script from "./CancelProcedure.vue?vue&type=script&lang=js&"
export * from "./CancelProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports